import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { RULE_ARITHMETIC_FUNCTION_TYPES } from 'yeself-common/enum/RuleEnum';

import SelectField from '../../components/SelectField';
import PlainStringField from '../../components/PlainStringField';

import { UserIdsRuleValues } from '../types';

type UserIdsRuleFieldProps = {
    value: UserIdsRuleValues;
    onChange: (value: UserIdsRuleValues) => void;
};

const UserIdsRuleField = ({ value, onChange }: UserIdsRuleFieldProps): React.ReactElement => {
    const [levelValue, setLevelValue] = useState({
        level0: value.level?.[0]?.data.key || null,
        level1: value.level?.[1]?.data.value || null,
    });

    const handleOnChange = useCallback(
        (index: number) => (newValue) => {
            const newLevelValue = { ...levelValue, [`level${index}`]: newValue };

            const level: UserIdsRuleFieldProps['value']['level'] = [
                newLevelValue.level0 ? { data: { key: newLevelValue.level0 } } : undefined,
                newLevelValue.level1 ? { data: { value: newLevelValue.level1 } } : undefined,
            ];

            setLevelValue(newLevelValue);
            onChange({ ...value, level });
        },
        [levelValue, onChange, value]
    );

    return (
        <>
            <SelectField
                autoWidth
                options={[
                    {
                        label: <FormattedMessage id="Rules.level.is" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.IS,
                    },
                    {
                        label: <FormattedMessage id="Rules.level.not" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.NOT,
                    },
                ]}
                value={levelValue.level0 || ''}
                onChange={handleOnChange(0)}
            />
            {levelValue.level0 ? (
                <PlainStringField value={levelValue.level1 || ''} onChange={handleOnChange(1)} />
            ) : null}
        </>
    );
};

export default UserIdsRuleField;
